import { createBody } from './create-body';
import {fetch, fetchNApi, } from './fetch';

export const post = <T = unknown>(
    url: string,
    data: unknown = null,
    init: RequestInit | null = null,
    isAnon: boolean = false,
): Promise<T> => fetch<T>(
    url,
    {
        method: 'POST',
        body: createBody(data),
        ...init,
    },
    isAnon,
);

export const postNApi = <T = unknown>(
    url: string,
    data: unknown = null,
    init: RequestInit | null = null,
    isAnon: boolean = false,
): Promise<T> => fetchNApi<T>(
    url,
    {
        method: 'POST',
        body: createBody(data),
        ...init,
    },
    isAnon,
);
